import { OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
var CustomPopupComponent = /** @class */ (function () {
    function CustomPopupComponent(bsModalRef, speechRecognitionService) {
        this.bsModalRef = bsModalRef;
        this.speechRecognitionService = speechRecognitionService;
        this.isInputEmpty = false;
        this.respondObject = {};
        this.optionList = [];
    }
    CustomPopupComponent.prototype.ngOnInit = function () {
        this.buildOptionList();
    };
    CustomPopupComponent.prototype.ngAfterViewInit = function () {
        var inputElem = this.textbox.nativeElement;
        inputElem.select();
    };
    CustomPopupComponent.prototype.respond = function (answer) {
        if (!this.inputText && answer == "OK") {
            this.isInputEmpty = true;
        }
        else {
            this.answer = answer;
            this.respondObject = { "filter": this.option.SelectedItem, "value": this.inputText };
            this.bsModalRef.hide();
        }
    };
    CustomPopupComponent.prototype.onChange = function () {
        if (!this.inputText) {
            this.isInputEmpty = true;
        }
        else {
            this.isInputEmpty = false;
        }
    };
    CustomPopupComponent.prototype.enter = function (value) {
        this.inputText = value;
        this.respond("OK");
    };
    CustomPopupComponent.prototype.buildOptionList = function () {
        this.optionList.push({ ItemDisplay: "Equals", ItemValue: "EQUALS" });
        this.optionList.push({ ItemDisplay: "Not Equals", ItemValue: "NOTEQUALS" });
        this.optionList.push({ ItemDisplay: "Contains", ItemValue: "CONTAINS" });
        this.optionList.push({ ItemDisplay: "Not Contain", ItemValue: "NOTCONTAINS" });
        this.optionList.push({ ItemDisplay: "Starts With", ItemValue: "STARTSWITH" });
        this.optionList.push({ ItemDisplay: "Ends With", ItemValue: "ENDSWITH" });
        this.optionList.push({ ItemDisplay: "Greater Than", ItemValue: "GREATERTHAN" });
        this.optionList.push({ ItemDisplay: "Greater Than Equals", ItemValue: "GREATERTHANEQUALS" });
        this.optionList.push({ ItemDisplay: "Less Than", ItemValue: "LESSTHAN" });
        this.optionList.push({ ItemDisplay: "Less Than Equals", ItemValue: "LESSTHANEQUALS" });
        this.optionList.push({ ItemDisplay: "In", ItemValue: "IN" });
        this.option = new Option();
        if (this.selectedItem) {
            this.option.SelectedItem = this.selectedItem;
        }
        else {
            this.option.SelectedItem = "EQUALS";
        }
    };
    CustomPopupComponent.prototype.clearFilter = function () {
        this.answer = "CLEAR";
        this.respondObject = { "clearFilter": true };
        this.bsModalRef.hide();
    };
    return CustomPopupComponent;
}());
export { CustomPopupComponent };
var Option = /** @class */ (function () {
    function Option() {
    }
    return Option;
}());
export { Option };
var CustomOptionObject = /** @class */ (function () {
    function CustomOptionObject() {
    }
    return CustomOptionObject;
}());
export { CustomOptionObject };
